export default __webpack_public_path__ + "static/media/video-play.df8d883a.svg";